<template>
    <div>
        <div class="container-fluid mt-2 mb-5">
            <div class="row">
                <!-- Form section -->
                <div class="col-md-12 mb-3">
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title">📝 Agregar Adicional a Nota Médica</h5>
                            <p class="text-muted mt-2">Los campos marcados con <span class="text-danger">*</span> son obligatorios.</p>
                            <div class="row">
                                <div class="col-md-12 mb-3">
                                    <label class="form-label">Descripción <span class="text-danger">*</span></label>
                                    <textarea class="form-control" rows="4" maxlength="1000" v-model.trim="descripcion"></textarea>
                                    <small class="text-muted">Ingrese aquí cualquier información adicional relevante para la nota médica.</small>
                                </div>
                                <div class="col-md-12 mt-3 text-center">
                                    <vs-button v-if="userStats !== 1" type="submit" color="rgb(59,222,200)" gradient block @click="agregarAdicional">
                                        💾 Guardar Adicional
                                    </vs-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Display section -->
                <div class="col-md-12 mt-3 mb-3">
                    <div class="row">
                        <div class="col-md-12">
                            <h5 class="card-title">📄 Adicionales Registrados</h5>
                        </div>
                        <div v-if="adicionales.length === 0" class="col-md-12 text-center mt-3">
                            <p>No hay adicionales registrados para esta nota médica.</p>
                        </div>
                        <div class="col-md-12 mt-3" v-for="adicional in adicionales" :key="adicional.id">
                            <div class="card h-100">
                                <div class="card-header">
                                    <small class="text-muted">📅 Fecha de creación: {{ adicional.creado_en ? formatDate(adicional.creado_en) : 'No aplica' }}</small>
                                </div>
                                <div class="card-body">
                                    <p class="smallText text-start">
                                        <strong>Descripción:</strong> {{ adicional.descripcion || 'No aplica' }}
                                    </p>
                                </div>
                                <!-- Optional: Add footer for actions like delete if needed later -->
                                <!-- <div class="card-footer">
                                    <a class="smallText text-center" @click="eliminarAdicional(adicional.id)" href="#">
                                        ❌ Eliminar
                                    </a>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
var config = require("@/config/api.json");
const API = config.api;

export default {
    name: "AdicionalesNotaMedica",
    props: {
        currentUser: {
            type: Object,
            required: true
        },
        paciente: { // Although passed, it's not directly used here but kept for context consistency
            type: Object,
            required: true
        },
        nota_medica_id: {
            type: [Number, String], // Can be number or string from route params/props
            required: true
        }
    },
    data() {
        return {
            userStats: null,
            descripcion: '',
            adicionales: [] // Array to store fetched adicionales
        };
    },
    methods: {
        // Removed vEmpty - uses mixin version
        // Removed notify - uses mixin version
        // Removed openLoading - uses mixin version
        // Removed closeLoading - uses mixin version
        // Removed formatDate - uses mixin version

        async fetchAdicionales() {
            if (!this.nota_medica_id) {
                // this.notify('warning', 'No se ha proporcionado un ID de nota médica.');
                this.adicionales = []; // Clear if no ID
                return;
            }
            this.openLoading();
            try {
                const response = await axios.get(`${API}/obtener_adicionales_nota_medica`, {
                    params: { nota_medica_id: this.nota_medica_id }
                });
                if (response.data.status === 'success') {
                    this.adicionales = response.data.data;
                } else {
                    this.notify('error', 'Error al obtener los adicionales de la nota médica.');
                    this.adicionales = []; // Clear on error
                }
            } catch (error) {
                this.notify('error', `Error al obtener adicionales: ${error.response?.data?.message || error.message}`);
                this.adicionales = []; // Clear on error
            } finally {
                this.closeLoading();
            }
        },

        async agregarAdicional() {
            // Uses mixin vEmpty
            if (!this.vEmpty(this.descripcion, 'Descripción')) return;
            if (!this.nota_medica_id) {
                this.notify('error', 'No se puede guardar el adicional sin un ID de nota médica asociado.');
                return;
            }

            this.openLoading();
            try {
                const payload = {
                    nota_medica_id: this.nota_medica_id,
                    descripcion: this.descripcion
                };

                const response = await axios.post(`${API}/insertar_adicional_nota_medica`, payload);

                if (response.data.status === 'success') {
                    this.notify('success', 'Adicional agregado exitosamente.');
                    await this.callAudit(this.currentUser.mainId, "CREAR", "adicionales_nota_medica", this.nota_medica_id, `Datos adicionales agregados a nota médica`);

                    this.descripcion = ''; // Clear the form field
                    this.closeLoading();
                    await this.fetchAdicionales(); // Refresh the list
                    this.$emit('adicionalAgregado'); // Optional: Emit event if parent needs to know
                } else {
                    this.notify('error', `Error al guardar: ${response.data.message || 'Ocurrió un error desconocido.'}`);
                    this.closeLoading();
                }
            } catch (error) {
                this.notify('error', `Error al guardar el adicional: ${error.response?.data?.message || error.message}`);
                this.closeLoading();
            } finally {
                this.closeLoading();
            }
        }
    },
    watch: {
        // Watch for changes in nota_medica_id prop and refetch data
        nota_medica_id(newId, oldId) {
            if (newId !== oldId) {
                this.fetchAdicionales();
            }
        }
    },
    mounted() {
        this.fetchAdicionales(); // Fetch data when the component is mounted
         setTimeout(() => {
                this.userStats = this.getUserStatus();
            }, 500);
    }
};
</script>

<style scoped>
/* Add component-specific styles here if needed */
.smallText {
    font-size: 0.9em;
}
.card-header small {
    font-size: 0.8em;
}
</style>
